//@flow

import * as React from 'react';
import styled from 'styled-components';
import OpenIcon from './../icons/collapseOpen.svg';
import CloseIcon from './../icons/collapseClose.svg';
import ReactSVG from 'react-svg'

type State = {
    open: Boolean,
    actionButton: () => ReactNode,
};

type Props = {
    title: string,
    toggle: () => void,
};

const CollapseContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;  
    justify-content: center;
    align-items: center;
    margin: 5px 0;
    color: #2d2d2d;
    font-size: 14px;
    font-weight: 700;
`;

const CollapseHeader = styled.div`
    display: flex;
`;

const CollapseTitle = styled.div`
    width: calc(100% - 30px);
    display: flex;
    align-items: center;
`;

const CollapseChildren = styled.div`
    padding-left: 10px;
`;

export default class CollapsibleItem extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            open: Boolean(this.props.startOpen),
        }
        this.toggle = this.toggle.bind(this);
    }

    toggle(e) {
        this.setState({ open: !this.state.open })
    }

    render() {
        return (
            <div>
                <CollapseHeader>
                    {this.props.actionButton && this.props.actionButton}
                    <CollapseContainer onClick={(e) => this.toggle(e)}>
                        <CollapseTitle>{this.props.title}</CollapseTitle>
                        <ReactSVG
                            path={this.state.open ? OpenIcon : CloseIcon}
                            style={{
                                width: '18px',
                                height: '18px'
                            }}
                        />
                    </CollapseContainer>
                </CollapseHeader>
                <CollapseChildren style={this.state.open ? {} : { display: 'none' }}>
                    {this.props.children}
                </CollapseChildren>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// ./src/components/CollapsibleItem.jsx